import { defineMessages } from 'react-intl';

type MessageKeys = 'actionMessage';

const message: Record<MessageKeys, { id: string; defaultMessage: string; description?: string }> =
	defineMessages({
		actionMessage: {
			id: 'ai-mate.message-actions.automation-rule-update-action.action-message',
			defaultMessage: 'Updating automation',
			description: 'Message to show when autoamtion rule is received',
		},
	});

export default message;
